/* FlexFit Uniforms — variant picker.
   Makes colour/size selection change the real variant: URL, hidden input,
   price, gallery image and the add-to-cart button state. */
(function () {
  'use strict';

  var form = document.getElementById('product-form');
  var mapEl = document.querySelector('[data-variant-map]');
  if (!form || !mapEl) return;

  var variants;
  try {
    variants = JSON.parse(mapEl.textContent);
  } catch (e) {
    // A broken variant map silently disables the whole picker, which makes the
    // add-to-cart form submit the FIRST variant regardless of what's chosen.
    // The usual cause is a Liquid error printed inside [data-variant-map] JSON
    // (e.g. an image_url filter erroring on a variant with no image). Surface it
    // loudly so it's obvious in the console instead of failing silently.
    console.error(
      '[variant-picker] Could not parse [data-variant-map] — variant switching is DISABLED, ' +
      'so add-to-cart will submit the first variant. Check the JSON in ' +
      'sections/main-product.liquid for a "Liquid error" string.',
      e
    );
    var badText = (mapEl.textContent || '').trim();
    var hit = badText.indexOf('Liquid error');
    if (hit !== -1) {
      console.error('[variant-picker] Offending snippet:\n' + badText.slice(Math.max(0, hit - 60), hit + 120));
    }
    return;
  }
  if (!Array.isArray(variants) || variants.length === 0) {
    console.error('[variant-picker] [data-variant-map] parsed but is empty — variant switching disabled.');
    return;
  }

  var idInput = form.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('.pdp__price');
  var submit = form.querySelector('button[type="submit"]');
  var mainImg = document.querySelector('[data-gallery-main]');
  var counter = document.querySelector('[data-gallery-count]');

  function selection() {
    var chosen = [];
    document.querySelectorAll('[data-option-group]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      var active = group.querySelector('[aria-pressed="true"]');
      if (!active) return;
      var holder = active.closest('[data-option-value-name]') || active;
      chosen[pos - 1] = holder.getAttribute('data-option-value-name') || active.getAttribute('data-value');
    });
    return chosen;
  }

  function match(chosen) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return chosen[i] == null || opt === chosen[i];
      });
    });
  }

  /* Grey out sizes that don't exist in the chosen colour */
  function refreshAvailability(chosen) {
    document.querySelectorAll('[data-option-group]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      group.querySelectorAll('[data-option-value-name]').forEach(function (el) {
        var trial = chosen.slice();
        trial[pos - 1] = el.getAttribute('data-option-value-name');
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (opt, i) {
            return trial[i] == null || opt === trial[i];
          });
        });
        var btn = el.matches('button') ? el : el.querySelector('button');
        if (!btn) return;
        if (btn.classList.contains('size')) {
          // Size not made in the chosen colour: cross it out and lock it
          btn.classList.toggle('is-unavailable', !exists);
          btn.disabled = !exists;
          btn.setAttribute('aria-disabled', String(!exists));
        } else {
          btn.classList.toggle('swatch--out', !exists);
        }
      });
    });
  }

  function apply(variant) {
    if (!variant) {
      if (submit) { submit.disabled = true; submit.textContent = window.themeStrings ? window.themeStrings.unavailable : 'Unavailable'; }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (submit) {
      submit.disabled = !variant.available;
      var t = window.themeStrings || {};
      submit.textContent = variant.available ? (t.addToCart || 'Add to cart') : (t.soldOut || 'Sold out');
    }

    if (priceEl) {
      priceEl.innerHTML = variant.on_sale
        ? '<span style="color:var(--signal)">' + variant.price + '</span> <s>' + variant.compare_at_price + '</s>'
        : variant.price;
    }

    if (mainImg && variant.image) {
      mainImg.src = variant.image;
      mainImg.removeAttribute('srcset');
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (t, i) {
        var on = i + 1 === variant.media_position;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      });
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option-group] button');
    if (!btn || btn.disabled) return;
    // theme.js has already moved aria-pressed by this point
    setTimeout(function () {
      var chosen = selection();
      refreshAvailability(chosen);
      apply(match(chosen));
    }, 0);
  });

  refreshAvailability(selection());
})();